import { render, staticRenderFns } from "./WordFrame.vue?vue&type=template&id=ef1f3438&"
import script from "./WordFrame.vue?vue&type=script&lang=js&"
export * from "./WordFrame.vue?vue&type=script&lang=js&"
import style0 from "./WordFrame.vue?vue&type=style&index=0&id=ef1f3438&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports